import script from "./MultiTab.vue?vue&type=script&lang=jsx"
export * from "./MultiTab.vue?vue&type=script&lang=jsx"

import "./MultiTab.vue?vue&type=style&index=0&id=62d528bd&lang=less&scoped=true"
import "./MultiTab.vue?vue&type=style&index=1&id=62d528bd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d528bd"]])

export default __exports__